import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';

import { useUser } from '@/hooks/useUser';

export const Route = createFileRoute('/investigations/$investigationId')({
  component: InvestigationRedirect,
});

/**
 * The address a ticket comment links to. It names no organization, so that a
 * rename cannot break links already posted; the signed-in session supplies it.
 */
function InvestigationRedirect() {
  const { investigationId } = Route.useParams();
  const { organizationName } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    if (organizationName) {
      navigate({
        to: '/$organizationName/investigations/$investigationId',
        params: { organizationName, investigationId },
        replace: true,
      });
    }
  }, [organizationName, investigationId, navigate]);

  return null;
}
